import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  font-size: 14px;
`;

interface Props {
  careTypes: string[];
  dataTestId?: string;
}

const CMASummaryTableDataCareTypes = ({ careTypes, dataTestId }: Props) => {
  return (
    <Container data-test-id={dataTestId}>
      {(careTypes ?? []).map((careType) => (
        <div key={careType}>{careType}</div>
      ))}
    </Container>
  );
};

export default CMASummaryTableDataCareTypes;
